import React, { Component } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import AudioFileIcon from '@mui/icons-material/AudioFile';
import ImageResize from 'quill-image-resize-module-react';

import './style.scss';

const Quill = ReactQuill.Quill;
const BlockEmbed = Quill.import('blots/block/embed');
const Inline = Quill.import('blots/inline');

class WordBlot extends BlockEmbed {
  static create(data) {
    let node = super.create();
    node.setAttribute('href', data.url);
    node.setAttribute('class', 'word-item');
    node.setAttribute('target', '_blank');
    node.setAttribute('name', data.filename || 'Unknown File'); // Сохраняем имя файла в атрибуте 'name'
    node.innerHTML = data.filename || 'Unknown File'; // Используем название файла или 'Unknown File', если название не предоставлено

    return node;
  }

  static value(node) {
    return {
      url: node.getAttribute('href'),
      filename: node.getAttribute('name') || node.innerText, // Если внутренний текст отсутствует, то возвращаем значение из атрибута 'name'
    };
  }
}

class DividerBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('controls', '');
    node.setAttribute('class', 'line-row-homework-c');
    return node;
  }
}
class AudioBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('src', url);
    node.setAttribute('controls', '');
    node.setAttribute('class', 'audio-item');
    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

class ImageBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('src', url);
    node.setAttribute('class', 'image-item');
    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

class VideoBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('src', url);
    node.setAttribute('controls', '');
    node.setAttribute('class', 'video-item');
    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

class LinkBlot extends Inline {
  static create(url) {
    const node = super.create();
    node.setAttribute('href', url);
    node.setAttribute('class', 'link-item');
    node.setAttribute('target', '_blank');
    node.setAttribute('contenteditable', 'false');
    return node;
  }

  static formats(node) {
    return node.getAttribute('href');
  }

  static value(node) {
    return node.getAttribute('href');
  }
}

class ImageFormat extends Quill.import('formats/image') {
  static formats(domNode) {
    return {
      alt: domNode.getAttribute('alt'),
      src: domNode.getAttribute('src'),
      width: domNode.getAttribute('width'),
    };
  }
  format(name, value) {
    if (name === 'width') {
      this.domNode.setAttribute('width', value);
    } else {
      super.format(name, value);
    }
  }
}
class GetHomeworkComp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      homeWorkValue: '',
      contextObject: null,
      name: '',
      loading: false,
      content: '',
      message: '',
      deletedUrls: [],
      addedUrls: [],
      subject: '',
      subjects: [],
      isForNotebook: false,
      progressFilePost: 0,
      rowApdute: '',
      arrayFilesEditor: [],
      arrayFiles: [],
      readOnly: true,
    };

    this.context = React.createRef();
    this.setContext = this.setContext.bind(this);
    this.handleImage = this.handleImage.bind(this);
    this.handleVideo = this.handleVideo.bind(this);
    this.handleMusic = this.handleMusic.bind(this);
    this.handleNewPart = this.handleNewPart.bind(this);
    this.onSubjectChange = this.onSubjectChange.bind(this);
    this.handleLinkInsert = this.handleLinkInsert.bind(this);

    AudioBlot.blotName = 'audio';
    AudioBlot.tagName = 'audio';

    ImageBlot.blotName = 'img';
    ImageBlot.tagName = 'img';

    VideoBlot.blotName = 'video';
    VideoBlot.tagName = 'video';

    DividerBlot.blotName = 'divider';
    DividerBlot.tagName = 'hr';

    WordBlot.blotName = 'word';
    WordBlot.tagName = 'a';

    LinkBlot.blotName = 'link';
    LinkBlot.tagName = 'span';

    Quill.register(AudioBlot);
    Quill.register(DividerBlot);
    Quill.register(ImageBlot);
    Quill.register(VideoBlot);
    Quill.register(LinkBlot);
    Quill.register('modules/imageResize', ImageResize);
    Quill.register('formats/word', WordBlot);
    Quill.register(ImageFormat, true);
  }

  componentDidMount() {
    this.setState({
      content: this.props.content.ops,
      id: this.props.content.id,
    });
  }

  getUrls(diffs) {
    return diffs.ops
      .filter(diff => diff.insert && (diff.insert.image || diff.insert.video || diff.insert.audio))
      .map(diff => {
        if (diff.insert.image) return diff.insert.image;

        if (diff.insert.video) return diff.insert.video;

        return diff.insert.audio;
      });
  }

  setContext(context) {
    this.setState({ contextObject: context });
  }

  CustomToolbar = () => (
    <div className="homework-edit-toolbar" id="toolbar">
      <button className="ql-bold" />
      <button className="ql-italic" />
      <select className="ql-color">
        <option value="red" />
        <option value="green" />
        <option value="blue" />
        <option value="orange" />
        <option value="violet" />
        <option value="#d0d1d2" />
      </select>
      <button
        className="ql-link"
        onClick={url => {
          this.handleLinkInsert(url);
        }}
      ></button>
      <button className="ql-insertLine ">Разделить Д/З</button>
      <button className="ql-image button-icon" />
      <button className="ql-video button-icon">video</button>
      <button className="ql-music button-icon">
        <AudioFileIcon />
      </button>
    </div>
  );

  handleImage() {
    this.handleFile('image/*', 'image');
  }

  handleVideo() {
    this.handleFile('video/mp4,video/x-m4v,video/*', 'video');
  }

  handleMusic() {
    this.handleFile('audio/*', 'audio');
  }

  handleLinkInsert = url => {
    if (url) {
      let quill = this.state.contextObject.getEditor();
      let selection = quill.getSelection(true);

      if (selection) {
        const { index } = selection;

        if (text) {
          const linkAttributes = url;
          const spanNode = document.createElement('span');
          spanNode.innerText = text;
          spanNode.setAttribute('href', linkAttributes);
          spanNode.setAttribute('class', 'link-item');
          spanNode.setAttribute('target', '_blank');
          spanNode.setAttribute('contenteditable', 'false');
          spanNode.addEventListener('click', () => {
            window.open(linkAttributes, '_blank');
          });

          quill.insertEmbed(index, 'link', linkAttributes, Quill.sources.USER);
          quill.insertText(index + 1, '\uFEFF');
          quill.setSelection(index + 1, Quill.sources.SILENT);
          quill.clipboard.dangerouslyPasteHTML(index + 1, spanNode.outerHTML);
          quill.setSelection(index + 1 + spanNode.innerText.length, Quill.sources.SILENT);
        }
      }
    }
  };

  handleNewPart() {
    let quill = this.state.contextObject.getEditor();
    let range = quill.getSelection(true);
    quill.insertEmbed(range.index, 'divider', true, Quill.sources.USER);
    quill.setSelection(range.index + 2, Quill.sources.SILENT);
  }

  onSubjectChange = e => {
    let subject = e.target.selectedIndex == 0 ? null : e.target.value;
    this.setState({
      subject,
    });
  };

  handleChange = (content, delta, source, editor) => {
    const htmlArray = content.split('<hr controls="" class="line-row-homework-c">');
    const finalHtmlArray = [];

    htmlArray.forEach(htmlString => {
      if (htmlString.includes('<hr')) {
        const splitHtmlArray = htmlString.split('<hr');
        splitHtmlArray.forEach(splitHtmlString => {
          if (splitHtmlString.trim() !== '') {
            finalHtmlArray.push(splitHtmlString);
          }
        });
      } else {
        finalHtmlArray.push(htmlString);
      }
    });

    if (this.props.setGetHomework) {
      this.props.setGetHomework(this.state.id, finalHtmlArray);
    }

    this.setState({ content });
  };

  render() {
    return this.state.loading ? (
      <span className="spinner-border spinner-border-sm"></span>
    ) : (
      <div className="editor-homework-page container">
        <div className="col-mg-12">
          <div>
            <ReactQuill
              modules={{
                toolbar: false,
                imageResize: {
                  parchment: Quill.import('parchment'),
                  modules: ['Resize'],
                },
              }}
              readOnly={true}
              value={this.state.content}
              theme="snow"
              onChange={this.handleChange}
            />
          </div>
          <br />
        </div>
      </div>
    );
  }
}

export default GetHomeworkComp;
